import { env } from './env';

export const environment = {
  production: false,
  apiPath: '/api/',
  apiDomain: 'tasteadvisor-staging.dev.firestitch.com',
  platform: (<any>env).platform,
  build: (<any>env).build,
  facebookAppId: '313779566199486',
  googleClientId: '963766214312-b7bmd6eqh0cc4foj2hldubmkuu2dq0qc.apps.googleusercontent.com',
  googleMapApiKey: 'AIzaSyDwK5HDj6mtad3wQNzS6ZauLe7raegSPpo',
  intercomAppId: 'q5sb8hgh',
  googleAnalyticsId: 'UA-138590760-1',
  firebaseLinkDomain: 'tasteadvisor.page.link',
  iosBundle: 'com.firestitch.stg.tasteadvisor',
  iosAppstoreId: '',
  androidBundle: 'com.firestitch.stg.tasteadvisor',
  urlScheme: 'tasteadvisorstg',
  iosAppstoreUrl: 'https://apps.apple.com/us/app/tasteadvisor-drink-local-wine/id1471572055?ls=1',
  androidAppstoreUrl: 'https://play.google.com/store/apps/details?id=com.firestitch.tasteadvisor',
  appName: 'Wines of BC Explorer (STG)'
};
